import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PinService {
  private readonly PinColors = [
    '#6d8cb2',
    '#6d8cb2',
    '#6d8cb2',
    '#6d8cb2',
    '#6d8cb2',
    '#6d8cb2',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#102a6a',
    '#062759',
    '#062759',
    '#062563',
    '#062563',
    '#062563',
    '#102a6a',
    '#14327c',
    '#1b398d',
    '#2e4598',
    '#2e4bb4',
    '#275bac',
    '#2f6ab5',
    '#2f6dcb',
    '#3174d0',
    '#3881d6',
    '#3d8be2',
    '#4295e0',
    '#469ed8',
    '#4eacdd',
    '#52b5d9',
    '#55bae1',
    '#58c2e7',
    '#5ecce9',
    '#62d6ea',
    '#64d9db',
    '#00ddb3',
    '#06efb2',
    '#03e59a',
    '#03dd7f',
    '#00d373',
    '#02cc68',
    '#05cc42',
    '#05d118',
    '#66d900',
    '#77e205',
    '#86e203',
    '#fdd915',
    '#ffd515',
    '#f7be1e',
    '#ff9700',
    '#f98e00',
    '#ff7900',
    '#ff6700',
    '#ff5b00',
    '#fc5603',
    '#f94a06',
    '#ff4200',
    '#ff3600',
    '#f92919',
    '#f92015',
    '#f71128',
    '#f91233',
    '#fc1515',
    '#f20606',
    '#ed0303',
    '#e50303',
    '#e00000',
    '#d30c25',
    '#c40a2a',
    '#b80000',
    '#a80202',
    '#990404',
    '#990404',
    '#990404',
    '#990404',
    '#8d0202',
    '#8e0202',
    '#8e0202',
    '#8e0202',
    '#8e0202',
    '#820303',
    '#820303',
    '#820303',
    '#820303',
    '#820303',
    '#720303',
    '#640202',
  ];

  loadIcons(): void {
    this.loadTemperatureIcons();
    this.loadRainIcons();
    this.loadWindIcons();
  }

  private loadTemperatureIcons(): void {
    const enc = new TextEncoder();
    const svgString =
      '<svg width="73" height="96" viewBox="0 0 73 96" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="ky34gzx61a"><feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset dy="8" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0855129076 0" in="shadowBlurOuter1"/></filter><path d="M19.455 35.047c0 20.444 27.238 50.624 27.238 50.624S73.93 55.49 73.93 35.047c0-15.07-12.179-27.259-27.237-27.259-15.059 0-27.238 12.189-27.238 27.26z" id="uhetb83a4b"/></defs><g transform="translate(-10.097 -5.43)" fill="none" fill-rule="evenodd"><use fill="#000" filter="url(#ky34gzx61a)" xlink:href="#uhetb83a4b"/><use stroke="#FFF" stroke-width="4" fill="#FF8700" xlink:href="#uhetb83a4b"/></g></svg>';

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    const allMetrics = [];
    for (let i = -40; i < 52; i++) {
      const pin = svgString.replace(/#FF8700/, this.PinColors[i + 40]);
      const buffer = enc.encode(pin);
      const encodedData = btoa(String.fromCharCode(...new Uint8Array(buffer)));
      allMetrics.push(this.loadSvg(`data:image/svg+xml;base64,${encodedData}`));
    }
    context.clearRect(0, 0, 73, 96);

    canvas.width = 73;
    canvas.height = 96;
    context.font = '600 24px sans-serif';
    context.textAlign = 'center';
    context.fillStyle = 'white';

    Promise.all(allMetrics).then((images) => {
      images.forEach((img, i) => {
        context.clearRect(0, 0, img.width, img.height);

        context.drawImage(img, 0, 0);
        const imageData = context.getImageData(0, 0, img.width, img.height);
        context.putImageData(imageData, 0, 0);
        context.fillText(`${i - 40}`, img.width / 2, img.height / 2 - 8);
        const newImg = context.getImageData(0, 0, img.width, img.height);
        window.map.addImage(`temperature-metric-${i - 40}`, newImg);
      });
    });

    const allImperials = [];
    for (let i = -40; i < 126; i++) {
      const pin = svgString.replace(/#FF8700/, this.PinColors[Math.round(((i - 32) * 5) / 9 + 40)]);
      const buffer = enc.encode(pin);
      const encodedData = btoa(String.fromCharCode(...new Uint8Array(buffer)));
      allImperials.push(this.loadSvg(`data:image/svg+xml;base64,${encodedData}`));
    }
    context.clearRect(0, 0, 73, 96);

    canvas.width = 73;
    canvas.height = 96;
    context.font = '600 24px sans-serif';
    context.textAlign = 'center';
    context.fillStyle = 'white';

    Promise.all(allImperials).then((images) => {
      images.forEach((img, i) => {
        context.clearRect(0, 0, img.width, img.height);

        context.drawImage(img, 0, 0);
        const imageData = context.getImageData(0, 0, img.width, img.height);
        context.putImageData(imageData, 0, 0);
        context.fillText(`${i - 40}`, img.width / 2, img.height / 2 - 8);
        const newImg = context.getImageData(0, 0, img.width, img.height);
        window.map.addImage(`temperature-imperial-${i - 40}`, newImg);
      });
    });
  }

  private loadRainIcons(): void {
    Promise.all(
      [0, 1, 2, 3, 4, 5, 6].map((value) =>
        window.map.loadImage(`/assets/rain-pins/${value}.png`).then((image) => {
          window.map.addImage(`rain-${value}`, image.data);
        }),
      ),
    );
  }

  private loadWindIcons(): void {
    Promise.all(
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((value) => {
        return [
          window.map
            .loadImage(`/assets/wind-pins/${value}.png`)
            .then((image) => window.map.addImage(`wind-${value}`, image.data)),
          window.map
            .loadImage(`/assets/wind-pins/no${value}.png`)
            .then((image) => window.map.addImage(`wind-no${value}`, image.data)),
        ];
      }),
    );
  }

  private loadSvg(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }
}
